import { render, staticRenderFns } from "./IndexNavigation.vue?vue&type=template&id=4e4ee4e8&scoped=true&"
import script from "./IndexNavigation.vue?vue&type=script&lang=js&"
export * from "./IndexNavigation.vue?vue&type=script&lang=js&"
import style0 from "./IndexNavigation.vue?vue&type=style&index=0&id=4e4ee4e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4ee4e8",
  null
  
)

export default component.exports